import React from 'react';
import {Link} from 'react-router-dom';

import {ErrorLoc} from '../loc/error';
import {loc} from '../lib/loc';

export default function NotFound({button}) {
  return <div className="section">
    <div id="content" className="container not-found" style={{width: 'auto'}}>
      <h1 className="big-header text-center">404</h1>
      <div className="text text-center text-gray text-italic">
        <p>{loc(ErrorLoc.notFound.one)}</p>
        <p>{loc(ErrorLoc.notFound.two)}</p>
        <p>{loc(ErrorLoc.notFound.three)}</p>
      </div>
      <div className="buttons text-center">
        <Link to={button && button.to ? button.to : "/"}>
          <span className="button red-button">{button && button.titile ? button.title : loc(ErrorLoc.notFound.toCabinet)}</span>
        </Link>
      </div>
    </div>
  </div>
}